import React from "react";

function SvgComponent() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        fill="currentColor"
        d="M1.666 18.333a6.667 6.667 0 1113.333 0h-1.666a5 5 0 00-10 0H1.666zm6.667-7.5c-2.763 0-5-2.237-5-5 0-2.762 2.237-5 5-5 2.762 0 5 2.238 5 5 0 2.763-2.238 5-5 5zm0-1.667a3.332 3.332 0 100-6.666 3.332 3.332 0 100 6.666zm6.903 3.086a6.668 6.668 0 013.93 6.081h-1.667a5 5 0 00-2.947-4.56l.684-1.521zm-.573-9.408a4.583 4.583 0 012.836 4.239 4.582 4.582 0 01-4.166 4.565V9.97a2.916 2.916 0 00.867-5.507l.463-1.619z"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.167 18.334H2.5v-1.667h11.667v1.667z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default SvgComponent;
